import { Delete } from 'assets/Icons'
import { Modal, Tooltip } from 'components/Overlay'
import Spinner from 'components/Spinner'
import notification from 'helpers/notification'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import services from 'services/index'

const DeleteStudent = ({ data, getGroupById, month }) => {
	const role = useSelector(state => state?.user?.user?.user_type)
	const params = useParams()
	const { id } = params
	const [dataBaza, setDataBaza] = useState()
	const [visibleDelete, setVisibleDelete] = useState(false)
	const [loading, setLoading] = useState(false)
	const deleteStudent = () => {
		const newStudentsList = dataBaza?.students?.filter(
			item => item?.id !== data?.id
		)
		const options = {
			data: {
				...dataBaza,
				students: newStudentsList?.map(item => item?.id),
				teachers: dataBaza?.teachers?.id,
			},
			onStart: () => setLoading(true),
			onError: error => notification('Error', { type: 'error' }),
			onEnd: () => setLoading(false),
			onSuccess: response => {
				if (response.status === 200) {
					notification("O'quvchi bu guruhdan chiqarildi.", { type: 'success' })
					setVisibleDelete(false)
					getGroupById(id)
				} else {
					notification('Error', { type: 'error' })
				}
			},
		}
		services.groups.updateGroups(options)
	}

	useEffect(() => {
		const options = {
			id,
			role,
			month,
			onEnd: () => setLoading(false),
			onStart: () => setLoading(true),
			onSuccess: response => setDataBaza(response?.data),
		}
		services.groups.getGroupById(options)
	}, [id])

	return (
		<Fragment>
			<Tooltip title="O'chirish" distance={6}>
				<button className='delete-icon' onClick={() => setVisibleDelete(true)}>
					<Delete />
				</button>
			</Tooltip>
			<Modal
				onClose={() => setVisibleDelete(false)}
				onOpen={() => setVisibleDelete(true)}
				open={visibleDelete}
			>
				{loading ? (
					<div className='w-[450px] h-[227px] flex items-center justify-center'>
						<Spinner />
					</div>
				) : (
					<div className='py-[32px] px-[24px]'>
						<h4 className='text-[#292B32] dark:text-[#f2f2f2] text-[24px] font-bold m-0 text-center'>
							Ma’lumotni o‘chirish
						</h4>
						<p className='text-[#292B32] dark:text-[#f2f2f2] text-lg font-medium mx-0 mt-[16px] mb-[0] text-center'>
							Haqiqatan ham ushbu ma’lumotni o‘chirmoqchimisiz?
						</p>
						<div className='flex justify-center items-center mt-[24px]'>
							<button
								className='mute-btn mr-5 min-w-[150px]'
								onClick={() => setVisibleDelete(false)}
							>
								Bekor qilish
							</button>
							<button
								className='danger-btn min-w-[150px]'
								onClick={() => deleteStudent(id)}
							>
								Ha
							</button>
						</div>
					</div>
				)}
			</Modal>
		</Fragment>
	)
}

export default DeleteStudent
